import React, { useState } from "react";
import { connect } from "react-redux";
import * as actions from "../../VenueManager/actions/venueManagerActionCreators";
import VenueCard from "./VenueCard";
import AddVenueModal from "./AddVenueModal";
import VenueFormModal from "./VenueFormModal";
import StageFormModal from "./StageFormModal";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";
import client from "../../../shared/api/client";
import { toastError, toastSuccess } from "../../../shared/toastHelper";

const SettingsVenueDetails = ({
  settingsPath,
  lastEditedAt,
  changelogVersions,
  venueOwnerships,
  csrfToken,
  team,
  venueStateOptions,
  availableTimezones,
  deleteVenueOwnership,
  createVenueOwnership,
  onVenueAdded,
  onVenueUpdated,
}) => {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [editingVenueOwnership, setEditingVenueOwnership] = useState(null);
  const [stageModalOpen, setStageModalOpen] = useState(false);
  const [editingRoom, setEditingRoom] = useState(null);
  const [stageVenueOwnership, setStageVenueOwnership] = useState(null);

  const handleAddVenue = (venueableId, venueableType) => {
    createVenueOwnership(csrfToken, team, venueableId, venueableType);
  };

  const handleManualEntry = () => {
    setAddModalOpen(false);
    setEditingVenueOwnership(null);
    setFormModalOpen(true);
  };

  const handleEdit = (venueOwnership) => {
    setEditingVenueOwnership(venueOwnership);
    setFormModalOpen(true);
  };

  const handleFormClose = () => {
    setFormModalOpen(false);
    setEditingVenueOwnership(null);
  };

  const handleAddStage = (venueOwnership) => {
    setStageVenueOwnership(venueOwnership);
    setEditingRoom(null);
    setStageModalOpen(true);
  };

  const handleEditStage = async (venueOwnership, room) => {
    try {
      const res = await client.get(`/teams/${team.id}/rooms/${room.id}/edit`);
      setStageVenueOwnership(venueOwnership);
      setEditingRoom(res.data);
      setStageModalOpen(true);
    } catch (error) {
      toastError("Failed to load stage for editing.");
    }
  };

  const handleStageModalClose = () => {
    setStageModalOpen(false);
    setEditingRoom(null);
    setStageVenueOwnership(null);
  };

  const handleToggleActive = async (venueOwnership) => {
    try {
      const res = await client.patch(`/teams/${team.id}/venue_ownerships/${venueOwnership.id}`, {
        venue_ownership: { active: !venueOwnership.active },
      });
      onVenueUpdated(res.data);
      toastSuccess(`${venueOwnership.name} marked ${res.data.active ? "active" : "inactive"}.`);
    } catch (error) {
      toastError("Failed to update venue status.");
    }
  };

  const handleStageChanged = (updatedVenueOwnership) => {
    onVenueUpdated(updatedVenueOwnership);
  };

  return (
    <SettingsPageWrapper settingsPath={settingsPath} title="Venues" lastEditedAt={lastEditedAt} changelogVersions={changelogVersions}>
      <VenueCard
        venueOwnerships={venueOwnerships}
        csrfToken={csrfToken}
        team={team}
        onAddVenue={() => setAddModalOpen(true)}
        onAddStage={handleAddStage}
        onEditStage={handleEditStage}
        onEdit={handleEdit}
        onDelete={deleteVenueOwnership}
        onToggleActive={handleToggleActive}
      />
      <AddVenueModal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onAddVenue={handleAddVenue}
        onManualEntry={handleManualEntry}
        venueOwnerships={venueOwnerships}
      />
      <VenueFormModal
        isOpen={formModalOpen}
        onClose={handleFormClose}
        csrfToken={csrfToken}
        team={team}
        venueStateOptions={venueStateOptions}
        availableTimezones={availableTimezones}
        onVenueAdded={onVenueAdded}
        venueOwnership={editingVenueOwnership}
        onVenueUpdated={onVenueUpdated}
      />
      <StageFormModal
        isOpen={stageModalOpen}
        onClose={handleStageModalClose}
        team={team}
        venueOwnership={stageVenueOwnership}
        room={editingRoom}
        onStageChanged={handleStageChanged}
      />
    </SettingsPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  venueOwnerships: state.venueOwnerships,
  csrfToken: state.csrfToken,
  team: state.team,
  venueStateOptions: state.venueStateOptions,
  availableTimezones: state.availableTimezones
});

const mapDispatchToProps = (dispatch) => ({
  deleteVenueOwnership: (csrfToken, team, venueOwnership) =>
    dispatch(actions.deleteVenueOwnership(dispatch, csrfToken, team, venueOwnership)),
  createVenueOwnership: (csrfToken, team, venueableId, venueableType) =>
    dispatch(actions.createVenueOwnership(dispatch, csrfToken, team, venueableId, venueableType)),
  onVenueAdded: (venueOwnership) =>
    dispatch(actions.venueOwnershipAdded(venueOwnership)),
  onVenueUpdated: (venueOwnership) =>
    dispatch(actions.venueOwnershipChanged(venueOwnership)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsVenueDetails);
